/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierBill } from './CourierBill';
import { CourierSettings, CourierSettingsFromJSON } from './CourierSettings';
import { LegalDocument, LegalDocumentFromJSON } from './LegalDocument';
import { OneSignal, OneSignalFromJSON } from './OneSignal';
import { RewardSettings, RewardSettingsFromJSON } from './RewardSettings';
import { Plan, PlanFromJSON } from './Plan';
import { StoreLocation } from './StoreLocation';
import { Stripe, StripeFromJSON } from './Stripe';
import { ThemeSetting, ThemeSettingFromJSON } from './ThemeSetting';
import { Wipay, WipayFromJSON } from './Wipay';
/**
 * 
 * @export
 * @interface Courier
 */
export interface Courier {
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    hostingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    slogan?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Courier
     */
    isActive?: boolean;
    /**
     * Server-derived: whether this courier's WhatsApp session is currently
     * connected/usable. Read-only; used by the customer portal to avoid
     * prompting for a WhatsApp code the session cannot deliver.
     * @type {boolean}
     * @memberof Courier
     */
    isWhatsappConnected?: boolean;
    /**
     *
     * @type {Date}
     * @memberof Courier
     */
    expiryDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof Courier
     */
    mailboxPaddingLength?: number;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    realm: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    webUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Courier
     */
    imageBucket?: string;
    /**
     * 
     * @type {number}
     * @memberof Courier
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Courier
     */
    planId?: number;

    plan?: Plan;

    storeLocations?: StoreLocation[];

    courierSetting?: Partial<CourierSettings>;

    courierBills?: CourierBill[];

    themeSetting?: Partial<ThemeSetting>;

    onboardingStatus?: "NOT_STARTED" | "IN_PROGRESS" | "COMPLETED";
    wipayCredentials?: Wipay;
    stripeCredentials?: Stripe;

    rewardSetting?: Partial<RewardSettings>;

    oneSignalCredentials?: OneSignal;

    legalDocument?: Partial<LegalDocument>;

    stripeCustomerId?: string;
    subscriptionId?: string;
    subscriptionStatus?: string;
    graceStartAt?: Date;
}

/**
 * Check if a given object implements the Courier interface.
 */
export function instanceOfCourier(value: object): value is Courier {
    if (!('realm' in value) || value['realm'] === undefined) return false;
    return true;
}

export function CourierFromJSON(json: any): Courier {
    return CourierFromJSONTyped(json, false);
}

export function CourierFromJSONTyped(json: any, ignoreDiscriminator: boolean): Courier {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'hostingUrl': json['hostingUrl'] == null ? undefined : json['hostingUrl'],
        'slogan': json['slogan'] == null ? undefined : json['slogan'],
        'email': json['email'] == null ? undefined : json['email'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isWhatsappConnected': json['isWhatsappConnected'] == null ? undefined : json['isWhatsappConnected'],
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'mailboxPaddingLength': json['mailboxPaddingLength'] == null ? undefined : json['mailboxPaddingLength'],
        'realm': json['realm'],
        'webUrl': json['webUrl'] == null ? undefined : json['webUrl'],
        'imageBucket': json['imageBucket'] == null ? undefined : json['imageBucket'],
        'id': json['id'] == null ? undefined : json['id'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'plan': json['plan'] == null ? undefined : PlanFromJSON(json['plan']),
        'storeLocations': json['storeLocations'] == null ? undefined : json['storeLocations'],
        'courierSetting': json['courierSetting'] == null ? undefined : CourierSettingsFromJSON(json['courierSetting']),
        'courierBills': json['courierBills'] == null ? undefined : json['courierBills'],
        'themeSetting': json['themeSetting'] == null ? undefined : ThemeSettingFromJSON(json['themeSetting']),
        'wipayCredentials': json['wipayCredentials'] == null ? undefined : WipayFromJSON(json['wipayCredentials']),
        'stripeCredentials': json['stripeCredentials'] == null ? undefined : StripeFromJSON(json['stripeCredentials']),
        'rewardSetting': json['rewardSetting'] == null ? undefined : RewardSettingsFromJSON(json['rewardSetting']),
        'oneSignalCredentials': json['oneSignalCredentials'] == null ? undefined : OneSignalFromJSON(json['oneSignalCredentials']),
        'legalDocument': json['legalDocument'] == null ? undefined : LegalDocumentFromJSON(json['legalDocument']),
        'stripeCustomerId': json['stripeCustomerId'] == null ? undefined : json['stripeCustomerId'],
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'graceStartAt': json['graceStartAt'] == null ? undefined : (new Date(json['graceStartAt'])),
        'onboardingStatus': json['onboardingStatus'] == null ? undefined : json['onboardingStatus'],
    };
}

export function CourierToJSON(json: any): Courier {
    return CourierToJSONTyped(json, false);
}

export function CourierToJSONTyped(value?: Courier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'imageUrl': value['imageUrl'],
        'hostingUrl': value['hostingUrl'],
        'slogan': value['slogan'],
        'email': value['email'],
        'isActive': value['isActive'],
        'isWhatsappConnected': value['isWhatsappConnected'],
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'mailboxPaddingLength': value['mailboxPaddingLength'],
        'realm': value['realm'],
        'webUrl': value['webUrl'],
        'imageBucket': value['imageBucket'],
        'id': value['id'],
        'planId': value['planId'],
        'plan': value['plan'],
        'storeLocations': value['storeLocations'],
        'courierSetting': value['courierSetting'],
        'courierBills': value['courierBills'],
        'themeSetting': value['themeSetting'],
        'wipayCredentials': value['wipayCredentials'],
        'stripeCredentials': value['stripeCredentials'],
        'rewardSetting': value['rewardSetting'],
        'oneSignalCredentials': value['oneSignalCredentials'],
        'legalDocument': value['legalDocument'],
        'stripeCustomerId': value['stripeCustomerId'],
        'subscriptionId': value['subscriptionId'],
        'subscriptionStatus': value['subscriptionStatus'],
        'graceStartAt': value['graceStartAt'] == null ? undefined : ((value['graceStartAt']).toISOString()),
        'onboardingStatus': value['onboardingStatus'],
    };
}


